export default __webpack_public_path__ + "static/media/a1-8.a61e5b01.png";